// extracted by mini-css-extract-plugin
module.exports = {"ListA2":"ListA2_ListA2__b3ATM"};